import { API_BASE_URL } from '../api';
export async function rebuildClients(ClientID,LocationID) {
     const updatedClient = {script: "getAllRecords"};
     try {
          const response = await fetch(API_BASE_URL + 'scripts.php', {
               method: "POST",
               headers: { "Content-Type": "application/json" },
               body: JSON.stringify(updatedClient),
          });
          const data = await response.json();
          return data;
     } catch (error) {
          alert("An error occurred Deleting Data??");
     }
}

export async function setButtons(whatLevel,locationCount,citationCount) {
     switch (whatLevel) {
          case 'ClientData' : 
               return [
                    { permission:"All", icon:"map", selected: true, label: `Locations (${locationCount + 1})`, action: 'ViewLocation' },
                    { permission:"All", icon:"customer", selected: false, label: "Edit Location", action: 'editCustomer' },
                    { permission:"All", icon:"edit", selected: false, label: `View Citations [${citationCount}]`, action: 'ViewCitations' },
               ];
          default : 
               return [
                    { permission:"All", icon:"map", selected: true, label: `Locations (${locationCount + 1})`, action: 'ViewLocation' },
                    { permission:"All", icon:"customer", selected: false, label: "Edit Location", action: 'editCustomer' },
                    { permission:"All", icon:"edit", selected: false, label: `View Citations [${citationCount}]`, action: 'ViewCitations' },
               ];
     }
}
